export default {
  namespaced: true,
  state: {
    beingEdited: 'open'
  },
  mutations: {
    toggleEdition (state, payload) {
      state.beingEdited = payload
    },
    reset (state) {
      state.beingEdited = 'open'
    }
  },
  getters: {
    isBeingEdited: state => state.beingEdited
  },
  actions: {
    assignEdited ({ getters, commit }, componentName) {
      commit('toggleEdition', componentName)
    }
  }
}
